import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { RequestCache } from "@app/core/shared/data/network/request-cache";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { Injectable } from "@angular/core";
import { RecentData } from "../../domain/model/recent-data";
import { RecentDataMapper } from "./recent-data.mapper";

/**
 * Web service to get the general statistics of the user.
 */
@Injectable({
  providedIn: "root",
})
export class RecentDataWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(limit: number, token: string): Observable<RecentData> {
    const parameters = new HandlerBuilder()
      .setMethod(HttpMethod.get)
      .setUrl(ApiUrls.GET_RECENT_DATA_ENDPOINT())
      .setUrlParams({ limit })
      .setAuthorization(new TokenAuthorization(token))
      // Same TTL as the matches list: recent data is derived from the same matches.
      .setCacheTtl(RequestCache.DEFAULT_TTL_MS)
      .build();
    return this.baseHandler
      .execute(parameters)
      .pipe(map((response) => RecentDataMapper.deserialize(response)));
  }
}
